import { Group } from "@dinahmoe/dmafjs-visual";
import { coreEngine, store } from "@dinahmoe/dmafjs-core";

class ConnectContainer extends Group {
  namespace = "se26:connectContainer";

  init(node, event) {
    super.init(node, event);
    node._cardNodes = [];
    node._collectedProjects = [];
    this.refresh(node);
  }

  state(node, config, event) {
    const parts = event.name.split(":");
    const action = parts[parts.length - 1];

    if (action === "card_toggle") {
      this.toggleCard(node, event);
    } else if (action === "contact") {
      this.handleContact(node, event);
    }
  }

  handleContact(node, event) {
    let link = event.data?.contactLink;
    if (!link) return;
    if (!link.startsWith("mailto:")) link = "mailto:" + link;
    node._ignoreNextToggle = true;
    window.location.href = link;
  }

  toggleCard(node, event) {
    if (node._ignoreNextToggle) {
      node._ignoreNextToggle = false;
      return;
    }
    const id = event.data?.id;
    const cardNode = node._cardNodes.find(c => c.id === id);
    if (!cardNode) return;

    const expandNode = cardNode._ids?.card_expand;
    if (!expandNode) return;

    const isExpanded = cardNode._isExpanded || false;
    const arrowNode = cardNode._ids?.card_arrow;

    if (isExpanded) {
      coreEngine.update({ uid: expandNode.uid, key: "transform", value: { transforms: [{ property: "size.height", valueEnd: 0, duration: 500, easing: "EASE_IN_OUT" }] } });
      if (arrowNode) arrowNode.transform.rotate = 0;
      cardNode._isExpanded = false;
    } else {
      coreEngine.update({ uid: expandNode.uid, key: "transform", value: { transforms: [{ property: "size.height", valueStart: 0, valueEnd: "auto", duration: 500, easing: "EASE_IN_OUT" }] } });
      if (arrowNode) arrowNode.transform.rotate = 180;
      cardNode._isExpanded = true;
    }
  }

  refresh(node) {
    this.clearCards(node);

    const projects = this.getProjects(node);
    if (!projects.length) return;

    const template = store.get("template.visual.connect_card");
    if (!template) return;

    projects.forEach((project, index) => {
      const cardNode = coreEngine.create({
        ...template,
        size: { width: 428 },
        parentUid: node.uid,
        id: `connect_card_${index}`,
        indexIds: true
      }, { key: "create_connect_card" });

      // Inject card id into click event data so toggleCard can identify which card was clicked
      const clickConfig = cardNode._dispatchConfigs?.click;
      if (clickConfig) {
        clickConfig.customData = { ...clickConfig.customData, id: `connect_card_${index}` };
      }

      const cardEls = cardNode._ids;
      if (cardEls) {
        if (cardEls.card_image && project.image) {
          const assetsPath = store.get("serve.assetsPath");
          cardEls.card_image['source.url'] = `${assetsPath}image/media/${project.image}`;
          if (project.image_alt_text) cardEls.card_image['source.alt'] = project.image_alt_text;
        }
        if (cardEls.card_headline) {
          cardEls.card_headline['text.content'] = project.headline || "";
        }
        if (cardEls.card_description) {
          cardEls.card_description['text.content'] = project.description || "";
        }
        if (cardEls.card_cta_text && project.contact_button_text) {
          cardEls.card_cta_text['text.content'] = project.contact_button_text;
        }
        if (cardEls.card_cta_button && project.contact_link) {
          const ctaDispatchConfig = cardEls.card_cta_button._dispatchConfigs?.click;
          if (ctaDispatchConfig) {
            ctaDispatchConfig.customData = { ...ctaDispatchConfig.customData, contactLink: project.contact_link };
          }
        }
      }

      node._cardNodes.push(cardNode);
    });
  }

  receiveMessage(node, message) {
    if (message.type === "projects_updated") {
      node._collectedProjects = message.projects || [];
      this.refresh(node);
      return;
    }
    super.receiveMessage(node, message);
  }

  getProjects(node) {
    const collected = node._collectedProjects || [];

    if (collected.length >= 4) return collected.slice(0, 4);

    // Fill remaining slots with random projects
    const allProjects = this.getAllProjects();
    const remaining = 4 - collected.length;
    const available = allProjects.filter(
      p => !collected.some(c => c.headline === p.headline)
    );

    // Shuffle and pick
    for (let i = available.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [available[i], available[j]] = [available[j], available[i]];
    }

    return [...collected, ...available.slice(0, remaining)];
  }

  getAllProjects() {
    const casesData = store.get("assets.data.cases_export");
    if (!casesData) return [];

    const projects = [];
    for (const caseStory of casesData.case_stories) {
      if (caseStory.projects) {
        projects.push(...caseStory.projects);
      }
    }
    return projects;
  }

  clearCards(node) {
    if (node._cardNodes) {
      node._cardNodes.forEach(cardNode => coreEngine.destroy(cardNode.uid));
      node._cardNodes = [];
    }
  }
}

const connectContainer = new ConnectContainer();
export { connectContainer, ConnectContainer };
